import { CUSTOM_ELEMENTS_SCHEMA, Injector, NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { KanbanPageComponent } from './kanban-page/kanban-page.component'
import { KanbanBoardComponent } from './widgets/kanban-board/kanban-board.component'
import { PhaseFormComponent } from './features/phase-form/phase-form.component'
import { DragDropModule } from '@angular/cdk/drag-drop'
import { provideHttpClient, withInterceptors } from '@angular/common/http'
import { createCustomElement } from '@angular/elements'
import { BrowserModule } from '@angular/platform-browser'
import { authInterceptor } from '../../shared/interceptors/auth/auth.interceptor'
import { KanbanRoutingModule } from './kanban-routing.module'
import { RouterModule } from '@angular/router'
import { environment } from '../../../environments/environment'

@NgModule({
  declarations: [KanbanPageComponent],
  imports: [CommonModule, DragDropModule, KanbanBoardComponent, PhaseFormComponent, BrowserModule, KanbanRoutingModule],
  providers: [provideHttpClient(withInterceptors([authInterceptor]))],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class KanbanModule {
  constructor(private injector: Injector) {}

  ngDoBootstrap() {
    const kanbanBoard = createCustomElement(KanbanBoardComponent, { injector: this.injector })
    customElements.define('visio-generic-kanban-wc', kanbanBoard)

    const phaseForm = createCustomElement(PhaseFormComponent, { injector: this.injector })
    customElements.define('kanban-phase-form', phaseForm)
  }
}
